<template>
  <div>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="Import"
        :static="true"
        :lazy="true"
      hide-footer
      :no-close-on-backdrop="busy"
      :no-close-on-esc="busy"
      :hide-header-close="busy"
    >
      <div class="modal-body">
        <fieldset :disabled="busy">
        <div class="form-group">
          <label for="localization-import-mode">Import mode</label>
          <select id="localization-import-mode" v-model="mode" class="form-control" :disabled="code !== 'en'">
            <option value="merge">Merge</option>
            <option value="replace">Replace English snapshot</option>
          </select>
          <div v-if="code === 'en' && mode === 'replace'" class="form-check mt-2">
            <input id="localization-replace-confirm" v-model="replaceConfirmed" type="checkbox" class="form-check-input">
            <label for="localization-replace-confirm" class="form-check-label">Confirm deletion of keys absent from the file</label>
          </div>
        </div>
        <div class="row">

          <div class="form-group col">
            <label class="form-label">Language</label>
            <b-form-select v-model="code" :options="codeOptions"></b-form-select>
          </div>
          <div class="form-group col">
            <label class="form-label">Format</label>
            <div class="pt-1">
              <div class="form-check form-check-inline">
                <b-form-radio v-model="format" name="format" value="json">json</b-form-radio>
              </div>
              <div class="form-check form-check-inline">
                <b-form-radio v-model="format" name="format" value="csv">csv</b-form-radio>
              </div>
            </div>
          </div>
          <div class="form-group col">
            <label class="form-label">File</label>
            <div class="form-file d-flex align-items-center">
              <input ref="fileInput" name="file" type="file" class="form-control-file d-none" accept=".csv,.json"
                     @change="onFileChange">
              <a href="javascript: void(0)" @click="triggerFileInput">Select file</a>
              <br>
              <span v-if="fileName" class="file-name">{{ fileName }}</span>
            </div>
          </div>
          <div class="form-group col">
            <template v-if="format === 'csv'">
              <label class="form-label">Separator</label>
              <input v-model="separator" type="text" class="form-control form-control-sm" maxlength="1">
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <button class="btn btn-default" v-on:click="hide">Close</button>
            <button type="button" @click="importTranslation" class="btn btn-success pull-right">Import</button>
          </div>
        </div>

        </fieldset>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalShow: false,
      format: 'json',
      code: 'en',
      fileName: '',
      separator: ';',
      mode: 'merge', replaceConfirmed: false, busy: false
    }
  },
  props: [
    'languages'
  ],
  methods: {
    importTranslation() {
      if (this.busy) return;
      if (!this.$refs.fileInput.files.length || (this.code === 'en' && this.mode === 'replace' && !this.replaceConfirmed)) {
        this.$toastr.e('Select a file and confirm replacement deletions.');
        return;
      }
      this.busy = true;
      const fd = new FormData();
      fd.append('mode', this.code === 'en' ? this.mode : 'merge');
      fd.append('code', this.code);
      fd.append('format', this.format);
      fd.append('file', this.$refs.fileInput.files[0]);
      if (this.format === 'csv') {
        fd.append('separator', this.separator);
      }

      this
          .$http({
            url: '/api/v1/localization/import',
            method: 'POST',
            data: fd,
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then((resp) => {
            this.$emit('onComplete');
            this.modalShow = false;
            this.fileName = '';
            this.replaceConfirmed = false;
            this.$toastr.i(resp.data.message);

          })
          .catch((err) => {
            this.$toastr.e(err.response && err.response.data && err.response.data.message || 'Import failed.');
          })
          .finally(() => { this.busy = false; })
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.fileName = file ? file.name : '';
    },
    hide() {
      this.modalShow = false;
    },
  },
  computed: {
    codeOptions() {
      return this.languages
          .map((item) => {
            return {value: item.code, text: item.name + ' (' + item.code + ')'}
          })
          .sort((a, b) => a.text > b.text ? 1 : -1);
    }
  }
}
</script>

<style scoped>
.btn-upload {
  display: flex;
  align-items: center;
}

.btn-upload i {
  margin-right: 0;
}

.file-name {
  margin-left: 10px;
  font-size: 0.9rem;
  color: #6c757d;
  display: block;
}

.pull-right {
  float: right;
}
</style>
